var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiDev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8475_1560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3333 56.9264H13.3333C12.4493 56.9264 11.6014 56.5752 10.9763 55.9501C10.3512 55.325 10 54.4772 10 53.5931V13.5931C10 12.709 10.3512 11.8612 10.9763 11.2361C11.6014 10.611 12.4493 10.2598 13.3333 10.2598H66.6667C67.5507 10.2598 68.3986 10.611 69.0237 11.2361C69.6488 11.8612 70 12.709 70 13.5931V43.5931",
    stroke: "#BF4036",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 43.5928H70",
    stroke: "#BF4036",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6665 70.2598H38.3332",
    stroke: "#BF4036",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3332 56.9268L31.6665 70.2601",
    stroke: "#BF4036",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 63.5934L56.6667 70.2601L70 56.9268",
    stroke: "#BF4036",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8475_1560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0 0.259766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiDev);
export default __webpack_public_path__ + "static/media/multi-dev.4f53828b05c68e7f350dab985d22eda9.svg";
export { ForwardRef as ReactComponent };